export const MOCK_SITE_SAMPLE_IDS = {
  default: "0",
  optimisation_amber: "1",
  optimisation_tou: "2",
  notification_backup: "3",
  optimisation_amber_solar_topup: "4",
  optimisation_tou_solar_topup: "5",
  optimisation_tou_ev: "6",
  backup_active: "7"
};